import React from "react";

const ARTICLES = [
  { cat: "General health", title: "When a headache needs a doctor", excerpt: "Most headaches pass on their own. Here's when it's worth booking a consult." },
  { cat: "Women's health", title: "Understanding period pain", excerpt: "A guide to what's normal, what isn't, and when to seek advice." },
  { cat: "Men's health", title: "Blood pressure basics", excerpt: "The numbers explained — and why they matter earlier than you think." },
  { cat: "Mental wellbeing", title: "Sleep and stress", excerpt: "Small habit changes with outsized impact on your mental health." },
  { cat: "Skin", title: "Rash vs. reaction", excerpt: "How to tell the difference and what a dermatologist can do." },
  { cat: "Family health", title: "Fever in children", excerpt: "When to watch, when to worry, and when to book." },
];

export default function HealthInfo() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">Health Information</div>
        <h1 className="cm-h2">Evidence-first, plain-English.</h1>
        <p className="cm-body mt-3">Bite-sized articles written by our clinical team. Never a substitute for a consultation, but a good place to start.</p>
      </div>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ARTICLES.map((a, i) => (
          <article key={i} className="cm-card" data-testid={`article-${i}`}>
            <div className="text-xs uppercase tracking-wider text-[#4a90d9] font-semibold">{a.cat}</div>
            <h3 className="mt-2 font-semibold text-[#1a2b4a]">{a.title}</h3>
            <p className="text-sm text-[#475569] mt-2 leading-relaxed">{a.excerpt}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
